import React, { Suspense } from 'react';
import { WindowLocation } from '@reach/router';

import { ImageLoadingType } from '../../../UI/Image/Image';
import PhoneCard from '../../../PhoneCard/PhoneCard';
import { ContentfulForm, ContentfulPhone } from '../../../../ContentfulTypes';

const LazyPhoneCard = React.lazy(() => import('../../../PhoneCard/PhoneCard'));

interface Props {
  phone: ContentfulPhone;
  index: number;
  isFlagEnabled: boolean;
  location: WindowLocation<unknown>;
  phoneLabelData: ContentfulForm;
}
const createPhoneCard = ({
  phone,
  index,
  location,
  phoneLabelData,
}: Props) => {
  const PhoneComponent = PhoneCard;

  if (index > 6) {
    const Card = LazyPhoneCard;
    return (
      <Suspense key={phone.urlSlug}>
        <Card
          phone={phone}
          location={location}
          phoneLabels={phoneLabelData.formFields}
          imageLoadingType={ImageLoadingType.Lazy}
        />
      </Suspense>
    );
  }
  return (
    <PhoneComponent
      key={phone.urlSlug}
      phone={phone}
      location={location}
      phoneLabels={phoneLabelData.formFields}
    />
  );
};

export default createPhoneCard;
